var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95172 3.42188H4.97016C4.11506 3.42188 3.42188 4.11506 3.42188 4.97016V8.95172C3.42188 9.80681 4.11506 10.5 4.97016 10.5H8.95172C9.80681 10.5 10.5 9.80681 10.5 8.95172V4.97016C10.5 4.11506 9.80681 3.42188 8.95172 3.42188Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0298 3.42188H15.0483C14.1932 3.42188 13.5 4.11506 13.5 4.97016V8.95172C13.5 9.80681 14.1932 10.5 15.0483 10.5H19.0298C19.8849 10.5 20.5781 9.80681 20.5781 8.95172V4.97016C20.5781 4.11506 19.8849 3.42188 19.0298 3.42188Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95172 13.5H4.97016C4.11506 13.5 3.42188 14.1932 3.42188 15.0483V19.0298C3.42188 19.8849 4.11506 20.5781 4.97016 20.5781H8.95172C9.80681 20.5781 10.5 19.8849 10.5 19.0298V15.0483C10.5 14.1932 9.80681 13.5 8.95172 13.5Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0298 13.5H15.0483C14.1932 13.5 13.5 14.1932 13.5 15.0483V19.0298C13.5 19.8849 14.1932 20.5781 15.0483 20.5781H19.0298C19.8849 20.5781 20.5781 19.8849 20.5781 19.0298V15.0483C20.5781 14.1932 19.8849 13.5 19.0298 13.5Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconWhite);
export default __webpack_public_path__ + "static/media/dashboard-icon-white.fc2385b18005af1ed55686456a25ade5.svg";
export { ForwardRef as ReactComponent };